import { render, staticRenderFns } from "./stadium-apply.vue?vue&type=template&id=b2aa3592&scoped=true&"
import script from "./stadium-apply.vue?vue&type=script&lang=js&"
export * from "./stadium-apply.vue?vue&type=script&lang=js&"
import style0 from "./stadium-apply.vue?vue&type=style&index=0&id=b2aa3592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2aa3592",
  null
  
)

export default component.exports